import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import TopBar from "./components/TopBar";
import Home from "./pages/LandingPage";
import Exhibition from "./pages/Exhibition";
import Contact from "./pages/Contact";

const App = () => {
  return (
    <Router>
      <TopBar />
      {/* 
        Add some padding at the top in your pages 
        to ensure content is not hidden behind the fixed nav.
      */}
      <div className="pt-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/exhibition" element={<Exhibition />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
